// Runtime config: reads from window.__RUNTIME_CONFIG__ (Docker/CapRover)
// with fallback to import.meta.env.VITE_* (local dev with Vite)

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      SUPABASE_URL?: string;
      SUPABASE_ANON_KEY?: string;
      API_URL?: string;
    };
  }
}

const rc = window.__RUNTIME_CONFIG__ || {};

export const config = {
  supabaseUrl: rc.SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: rc.SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  apiUrl: rc.API_URL || import.meta.env.VITE_API_URL || 'https://api.qwickforge.com',
};
